export default __webpack_public_path__ + "static/media/l4.06859bb6.jpg";